import { Icon, Tooltip } from '@components';

import theme from '../../../themes/colors';

interface AmountInputTooltipProps {
  maxAmount: string;
  minAmount: string;
  tooltipId?: string;
  type?: 'default' | 'hasSubtext';
}

const AmountInputTooltip = ({
  maxAmount,
  minAmount,
  tooltipId,
  type = 'default'
}: AmountInputTooltipProps) => {
  const tooltipText = `Allowed amount is between ${minAmount} and ${maxAmount}`;
  return (
    <>
      {type === 'default' && (
        <>
          <Icon
            name="alert-circle"
            stroke={theme.subText}
            data-tooltip-id={`${tooltipId}_max-amount-icon`}
          />
          <Tooltip
            id={`${tooltipId}_max-amount-icon`}
            type="text"
            tooltipText={tooltipText}
            className="leading-5"
          />
        </>
      )}
      {type === 'hasSubtext' && (
        <div className="my-1 flex items-center gap-1 text-xs text-grey60">
          <Icon name="alert-circle" stroke={theme.subText} size="none" />
          Allowed amount is between {minAmount} and {maxAmount}
        </div>
      )}
    </>
  );
};

export default AmountInputTooltip;
